export default __webpack_public_path__ + "static/media/Phone.f4dbe6c0.svg";